<script>
  import { nav, go } from '../lib/nav.svelte.js';
  import { role, currentRole, signOut, mayVisit, institution } from '../lib/role.svelte.js';
  import { SELF } from '../../shared/config.js';
  import Button from './Button.svelte';

  const links = [
    { route: 'dashboard', label: 'Dashboard' },
    { route: 'disclosure', label: 'Sources' },
    { route: 'records', label: 'Records' },
    { route: 'partners', label: 'Partners' },
    { route: 'catalog', label: 'Catalog' },
    // Route ids are internal and stable; the label is what changed.
    { route: 'analysis', label: 'Comparisons' },
  ];

  // Only show what this role actually works with (roles.md).
  const visible = $derived(links.filter((l) => mayVisit(l.route)));

  // Highlight the top-level section for nested routes (disclosure/label etc.).
  const section = $derived(nav.route.split('/')[0]);

  function doSignOut() {
    signOut();
    go('login');
  }
</script>

<header class="wf2-header app-header">
  <a class="app-brand" href="#/dashboard">
    {institution().name}
    {#if institution().tagline}<small>{institution().tagline}</small>{/if}
  </a>

  {#if role.current}
    <nav class="app-nav">
      {#each visible as l}
        <a href={'#/' + l.route} class={section === l.route ? 'active' : ''}>{l.label}</a>
      {/each}
    </nav>
    <div class="app-headend">
      <!-- The role is who you are here; the WebID is what the institution is to
           its partners. Showing both keeps the distinction visible. -->
      <div class="app-whoami">
        {currentRole()?.label}<br /><code>{SELF.webId}</code>
      </div>
      <Button variant="secondary" onclick={doSignOut}>Sign out</Button>
    </div>
  {/if}
</header>
